<template>
  <table class="complaint-item">
    <tr>
      <th>投诉主体</th>
      <td>{{ item.defendant }}</td>
    </tr>
    <tr>
      <th>投诉事由</th>
      <td>{{ item.problem }}</td>
    </tr>
    <tr>
      <th>您的诉求</th>
      <td>{{ item.appeal }}</td>
    </tr>
    <tr>
      <th>详情描述</th>
      <td>{{ item.detail }}</td>
    </tr>
    <tr>
      <th>投诉时间</th>
      <td>{{dayjs(item.time).format('YYYY-MM-DD hh:mm:ss')}}</td>
    </tr>
    <tr>
      <th>投诉状态</th>
      <td><ComplaintStatus :status="item.status" /></td>
    </tr>
    <template v-if="['NORMAL', 'FINISH'].includes(item.status)">
      <tr v-if="item.reply">
        <th>回复内容</th>
        <td>{{ item.reply }}</td>
      </tr>
      <tr v-if="item.reply_time">
        <th>回复时间</th>
        <td>{{dayjs(item.reply_time).format('YYYY-MM-DD hh:mm:ss')}}</td>
      </tr>
      <tr v-if="item.status === 'NORMAL'">
        <th>操作</th>
        <td>
          <Button type="success" size="small" @click="submit(false)">满意，结束投诉</Button>
          <Button type="warning" size="small" @click="submit(true)">不满意，继续投诉</Button>
        </td>
      </tr>
    </template>
  </table>
</template>
<script>
import dayjs from 'dayjs'
import { useRouter } from 'vue-router'
import { Button } from 'vant'

import UI from '@/utils/ui'
import { sleep } from '@/utils/tools'
import { finishComplaint } from '@/api/complaint'

import 'vant/es/button/style'

export default {
  name: 'mLongListComplaintItem',
  components: { Button },
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  setup (props) {
    const router = useRouter()

    const submit = async (goNew) => {
      await finishComplaint(props.item.id)
      UI.total.success(`ID 为 ${props.item.id} 的投诉建议，已标记为已完成！`)
      if (goNew) {
        await sleep(1500)
        router.push('/complaint/add')
        UI.total.success('您不满意当前处理结果，可继续提交新的投诉建议！')
      }
    }
    return {
      dayjs,
      submit
    }
  }
}
</script>
